import { render, staticRenderFns } from "./MasterdataBusMatrixDeleteModal.vue?vue&type=template&id=2f249eae"
import script from "./MasterdataBusMatrixDeleteModal.vue?vue&type=script&lang=js"
export * from "./MasterdataBusMatrixDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports